import { useMemo } from 'preact/compat';
export function useLabel(termIds, terms) {
    return useMemo(() => termIds
        .map((termId) => { var _a, _b; return (_b = (_a = terms.find(({ id }) => id === termId)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''; })
        .join(', '), [termIds, terms]);
}
